import React, { Component } from 'react';
import config from 'react-global-configuration';
// Importação do Router
import { Redirect, Link } from 'react-router-dom';

// Importação da tabela
import Loading from '../Miscelania/Loading';
import Alerta from '../Miscelania/Alerta';
import RequestApi from '../Miscelania/RequestApi';
import InputMask from 'react-input-mask';

class Login extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  }
  desativar_alerta () {
    this.setState({status_alerta: 0});
  }

	 // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      username: '',
      password: '',
      mensagem: null,
    };
    this.desativar_alerta = this.desativar_alerta.bind(this);
    this.desativar_loading = this.desativar_loading.bind(this);

    this.login = this.login.bind(this);
  }

  login(event) {
    event.preventDefault();
    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    var datasave = {
      username: this.state.username,
      password: this.state.password,
      system: 'exam_instructor',
    };
    var self = this;
    fetch(config.get('api') + '/provas/instrutor/acessar', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      self.refs.request_api.validate(responseJson);
      if (responseJson.error === 'inexistent_user') {
        self.setState({status_alerta: 1});
        self.setState({mensagem_alerta: 'Usuário não cadastrato. Solicite a TI a criação do usuário.'});
        self.setState({tipo_alerta: 'erro'});
      } else if (responseJson.error === 'inactive_user') {
        self.setState({status_alerta: 1});
        self.setState({mensagem_alerta: 'Usuário inativo neste sistema. Solicite a TI a liberação do usuário.'});
        self.setState({tipo_alerta: 'erro'});
      } else if (responseJson.error === 'permissionless_user') {
        self.setState({status_alerta: 1});
        self.setState({mensagem_alerta: 'Usuário sem permissões para este sistema. Solicite a TI as permissões de acesso para este usuário.'});
        self.setState({tipo_alerta: 'erro'});
      } else if (responseJson.error === 'invalid_credentials' || responseJson.error === 'invalid_request' || responseJson.data.token === '{"error":"invalid_credentials","message":"The user credentials were incorrect."}') {
        self.setState({status_alerta: 1});
        self.setState({mensagem_alerta: 'Usuário ou senha inválidos.'});
        self.setState({tipo_alerta: 'erro'});
      } else {
        var url = '/provas/instrutor';
        var storage = {
          mensagem_alerta: responseJson.message,
          tipo_alerta: responseJson.status,
        };
        var now = new Date();
        var now_date = now.toISOString().slice(0,10);
        var now_hr = now.toISOString().slice(11,19);
        var now = now_date + ' ' + now_hr;
        var token = JSON.parse(responseJson.data.token.token);
        var storage_cid = {
          aid: responseJson.data.exam_info.staff_id,
          name: responseJson.data.exam_info.staff_name,
          sts: 1,
          rcode: token.refresh_token,
          acode: token.access_token,
          system: 'exam',
          last_update: now,
        };

        localStorage.setItem("verifica_mensagem", JSON.stringify(storage));
        localStorage.setItem("cid", JSON.stringify(storage_cid));

        self.setState({redirect_url: url});
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  render() {
    return (
<div>
  {(this.state.status_loading != 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
	{(this.state.status_alerta == 1) ? <Alerta mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /> : ""}
  <RequestApi ref={'request_api'} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="hidden-xs hidden-sm hidden-md user-wrapper" style={{backgroundImage: "url('" + config.get('cdn') + "/exam/login/login-fundo.jpg')"}}>
    <div className="user-layer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-md-offset-4">
            <div className="user-content text-center">
              <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGTREIN" />
              <p style={{marginTop: '-15px'}}><strong><em>Controle de Prova</em></strong></p>
              <form onSubmit={this.login}>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-at"></i></div>
                    <input type="text" name="username" className="form-control" placeholder="Seu e-mail" value={this.state.username} onChange={this.handleChange.bind(this, 'username')} />
                  </div>
                </div>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
                    <input type="password" name="password" className="form-control" placeholder="Sua senha" value={this.state.password} onChange={this.handleChange.bind(this, 'password')} />
                  </div>
                </div>
                <button className="btn btn-success btn-block btn-lg" type="submit"><i className="fa fa-fw fa-sign-in"></i> Acessar</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="user-wrapper visible-xs-block visible-sm-block visible-md-block" style={{backgroundImage: "url('" + config.get('cdn') + "/exam/login/login-fundo.jpg')"}}>
    <div className="user-layer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-md-offset-4">
            <div className="user-content text-center">
              <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGTREIN" />
              <p style={{marginTop: '-15px'}}><strong><em>Controle de Prova</em></strong></p>
              <form onSubmit={this.login}>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-at"></i></div>
                    <input type="text" name="username" className="form-control" placeholder="Seu e-mail" value={this.state.username} onChange={this.handleChange.bind(this, 'username')} />
                  </div>
                </div>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
                    <input type="password" name="password" className="form-control" placeholder="Sua senha" value={this.state.password} onChange={this.handleChange.bind(this, 'password')} />
                  </div>
                </div>
                <button className="btn btn-success btn-block btn-lg" type="submit"><i className="fa fa-fw fa-sign-in"></i> Acessar</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Components/Users/Login.js